<p-confirmDialog key="editError" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid2Col">
	<label>Locker Status:</label>
	<select class="form-control" [(ngModel)]="LockerStatusID" (ngModelChange)="onLockerStatusChange($event)">
		<option *ngFor="let r of lstLockerStatus" [ngValue]="r.ID">
			{{ r.Desc }}
		</option>
	</select>

	<label>Select Locker:</label>
	<select class="form-control" [(ngModel)]="SelectedLocker" (ngModelChange)="onLockerChange($event)">
		<option *ngFor="let r of lstLocker" [ngValue]="r">
			{{ r.LockerNum }}
		</option>
	</select>

	<label>Move In Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="AssignedDate" name="AssignedDate"></p-calendar>

	<label>Assigned To:</label>
	<label>{{ StudentName }}</label>

	<label>Locker Comments/Combination:</label>
	<textarea [(ngModel)]="LockerComment" rows="5" class="TextArea"></textarea>

	<label>Assignment Comments:</label>
	<textarea [(ngModel)]="AssignmentComment" rows="5" class="TextArea"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onEdit()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
